<template lang="pug">
.bg-page
  .container
    section
      .title-decoration
        .dot
        .dot
        .dot
        .dot
      h1 {{ $route.meta.title }}
      //- div(style="text-align: center;")
        a.btn.ghost-btn.red(href="https://www.elementaltotem.com/pages/wirforce", target="_blank") 前往商店
    section
      .tab-wrap
        .tab-item(v-for="(tab, index) in tabs", @click="nowTab = index", :class="{actived: nowTab === index}") {{ tab.name }}
    .mb-10
    section.shop-link(v-if="nowTab === 0")
      .section-title WF 系列周邊
      //- img(src="~assets/shopping/shopping01.png", style="width: 100%;")
      //- img(src="~assets/shopping/shopping02.png", style="width: 100%;")
      a.png-shadow(href="https://www.elementaltotem.com/pages/wirforce", target="_blank")
        img(src="~assets/shopping/shop1.png", style="width: 100%;")
        .mb-8
        img(src="~assets/shopping/shop2.png", style="width: 100%;")
        img(src="~assets/shopping/shop3.png", style="width: 100%;")
        img(src="~assets/shopping/shop4.png", style="width: 100%;")
        //- img(src="~assets/shopping/shop5.png", style="width: 100%;")
      a.box-shadow(href="https://www.elementaltotem.com/products/castle-shelving-designed-for-byoc", target="_blank")
        img(src="~assets/shopping/ET.jpg", style="width: 100%;")
        .mb-16
      a.png-shadow(href="https://www.elementaltotem.com/pages/wirforce", target="_blank")
        img(src="~assets/shopping/ET_1016.png", style="width: 100%;")
        .mb-16
        img(src="~assets/shopping/ET_0927.png", style="width: 100%;")
        .mb-16
        img(src="~assets/shopping/ET_1017.png", style="width: 100%;")
        //- .mb-6
        //- img(src="~assets/shopping/ET_0928.png", style="width: 100%;")
        .mb-8
      .mb-10
      div(style="text-align: center;")
        a.btn.ghost-btn.red(href="https://www.elementaltotem.com/pages/wirforce", target="_blank") 前往商店
    //- section(v-if="nowTab === 0")
    //-   .section-title WF 系列周邊
    //-   .paragraph-wrap
    //-     img(v-img:group="{src: ''}", src="http://fakeimg.pl/1920x1366/e0253f/fff/?text=shop&font=bebas", style="max-width: 100%")
    //-     //- .content
    //-       span •搭乘淡水線至捷運圓山站，下車後從1號出口出站。
    //-   div(style="text-align: center;")
    //-     a.btn.ghost-btn.red(href="https://www.elementaltotem.com/pages/wirforce", target="_blank") 前往商店
    .mb-10
    section.shop-link(v-if="nowTab === 1")
      .section-title 4Gamers Shop 特色商品
      a.box-shadow(href="https://shop.4gamers.com.tw/", target="_blank")
        //- img(v-img:group="{src: ''}", src="http://fakeimg.pl/1920x1366/e0253f/fff/?text=shop&font=bebas", style="max-width: 100%")
        img.add-margin(src="~assets/shopping/4g06.png", style="width: 100%;")
        img.add-margin(src="~assets/shopping/4g01.png", style="width: 100%;")
        img.add-margin(src="~assets/shopping/4g02.png", style="width: 100%;")
        img.add-margin(src="~assets/shopping/4g03.png", style="width: 100%;")
        img.add-margin(src="~assets/shopping/4g04.png", style="width: 100%;")
        img.add-margin(src="~assets/shopping/4g05.png", style="width: 100%;")
        //- .content
          span •搭乘淡水線至捷運圓山站，下車後從1號出口出站。
      .mb-10
      div(style="text-align: center;")
        a.btn.ghost-btn.red(href="https://shop.4gamers.com.tw/", target="_blank") 前往 4Gamers Shop
      .mb-40
</template>

<script>
import { mapGetters } from 'vuex'
// import _ from 'lodash'

export default {
  name: 'shopping',
  beforeRouteEnter (to, from, next) {
    next(vm => {
    })
  },
  beforeRouteLeave (to, from, next) {
    next(vm => {
    })
  },
  props: {
    fullScreenCount: {
      type: Object
    },
    isMobile: {
      type: Boolean
    },
    mobileMenuSwitch: {
      type: [Boolean, Function]
    },
    isPortrait: {
      type: Boolean
    }
  },
  data () {
    return {
      nowTab: 0,
      tabs: [
        {
          name: 'WF系列周邊'
        },
        {
          name: '4Gamers Shop'
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
    ])
  },
  methods: {
  },
  mounted () {
    // Place images after loaded
    this.$Lazyload.$on('loaded', () => {
      console.log('Loaded')
    })
  },
  watch: {
  },
  beforeDestroy () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import '~stylesheets/variables'
@import '~stylesheets/components'
@import '~stylesheets/mixin'
.paragraph-wrap
  img
    display: block
.shop-link
  .box-shadow
    img:hover
      box-shadow: 0 0 24px 3px rgba($red, 0.5)
  .png-shadow
   img:hover
    -webkit-filter: drop-shadow(0px 0px 10px rgba($red, 0.8))
    filter: drop-shadow(0px 0px 10px rgba($red, 0.8))
.add-margin
  margin: 8px 0
</style>



// WEBPACK FOOTER //
// shopping.vue?99a55482